/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { TransactionApiLogsAutoBulkContext } from '../contexts/TransactionApiLogsAutoBulkContext';
import { MachinesContext } from '../../../modules/machinesAdminManagement/contexts/MachinesContext';
import TransactionApiLogsAutoBulkList from './TransactionApiLogsAutoBulkList';
import MachineStatusBanner from '../../../modules/shared/machineManagement/MachineStatusBanner';

const TransactionApiLogsAutoBulkPage: React.FunctionComponent = () => {
  const [initialDataLoaded, setDataLoaded] = React.useState(false);

  const { fetchTransactionApiLogsAutoBulk, detailPage, activeMachine } = React.useContext(
    TransactionApiLogsAutoBulkContext,
  );
  const { fetchAutoBulkMachines } = React.useContext(MachinesContext);

  React.useEffect(() => {
    const getMachines = async () => {
      if (!initialDataLoaded) {
        setDataLoaded(true);
        fetchAutoBulkMachines();
      }
    };

    getMachines();
  }, [initialDataLoaded, setDataLoaded, fetchTransactionApiLogsAutoBulk]);

  const autoBulkTransactionApiLogPage = () => {
    if (detailPage) {
      return 'updatePage';
    }

    return 'listPage';
  };

  return (
    <>
      <MachineStatusBanner activeMachine={activeMachine} />
      {
        {
          listPage: <TransactionApiLogsAutoBulkList />,
        }[autoBulkTransactionApiLogPage()]
      }
    </>
  );
};

export default TransactionApiLogsAutoBulkPage;
